import { RegisterProps } from "./RegisterProps"
import "./Register.scss";
import EditPersonalInfoPopup from "../../content/Profile/EditPersonalInfoPopup/EditPersonalInfoPopup";
import { useCallback, useEffect, useState } from "react";
import usersService from "../../../Axios/services/users.service";

export const Register = (props: RegisterProps) => {

    const [user, setUser] = useState(null)
    const [mounted, setMounted] = useState(true)

    const pullUser = useCallback(async () => {
        try {
            let uid = props.location.search;
            if (uid) {
                uid = uid.replace('?uid=','');
                const user = await usersService.getUserById(uid);
                if (user && mounted)
                    setUser(user)
            }
        } catch (err) {
            console.error(err)
        }
    }, [props.location.search, mounted])


    useEffect(() => {
        pullUser()
        return () => {
            setMounted(false)
        }
    }, [pullUser])


    return (
        <div className="register-screen">
            <div className="triangle"></div>
            <div className="main-title"></div>
            <div className="form-wrapper d-flex justify-content-center">
                <EditPersonalInfoPopup history={props.history} pulledUser={user} isNew={true} />
            </div>
        </div>
    )
}